const bogotaDate = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Bogota',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
})

function calendarDay (date) {
  const parts = bogotaDate.formatToParts(date)
  const year = Number(parts.find(part => part.type === 'year').value)
  const month = Number(parts.find(part => part.type === 'month').value)
  const day = Number(parts.find(part => part.type === 'day').value)
  return Date.UTC(year, month - 1, day)
}

export function daysWithoutDelivered (delivery) {
  const elapsed = calendarDay(new Date()) - calendarDay(new Date(delivery.createdAt))
  return Math.max(0, elapsed / (1000 * 60 * 60 * 24))
}



// WEBPACK FOOTER //
// ./src/helpers/deliveryDays.js